import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm, useFormContext } from "react-hook-form"
import { FilterMatchMode } from "primereact/api"
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as myconst from "../../../constants/index"
import { Tooltip } from "primereact/tooltip";
import ParamsPopUp from "../Params-Info-popup";
import { InputTextarea } from "primereact/inputtextarea";
import { min } from "moment";
import SystemPromptModal from "components/SystemPromptModal";
import { Button } from "primereact/button";
import ReactMarkdown from 'react-markdown';
import styles from 'assets/styles/ai-chat-bot/markdownRenderer.module.css'; // Import your CSS module for React markdown
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { infoIcon } from "assets/icons";


interface Field {
	key: string;
	type: 'text' | 'dropdown' | 'password';
	label?: any
}

const ChatBotParams = ({ methods,
	fieldData,
	clientVersion,
	isChatBotDataChanged,
	setIsChatBotDataChanged,
	handelPrompt,
	textValue,
	setTextValue
}
	: any) => {

	const {
		// formState: { errors },
		getValues
	} = useForm()

	const { register, setValue, formState: { errors }, watch } = useFormContext()



	const Backendfeilds = myconst.ChatBotParamsFeilds;

	const [modalContent, setModalContent] = useState('');
	const [globalFilterValue, setGlobalFilterValue] = useState("")
	const [filters, setFilters] = useState<{ [s: string]: any }>()
	const [showSystemPromptModal, setShowSystemPromptModal] = useState<boolean>(false)
	const [test, setTest] = useState("");
	const [label, setLabel] = useState("");
	const [prompt, setPrompt] = useState("");
	const [tooltipPosition, setTooltipPosition] = useState({ left: 0, top: 0 });
	const [is_hover_eye, setIs_hover_eye] = useState<string>("");
	const [rangeValue, setRangeValue] = useState(getValues("faiss_vactor_db.source_info_threshold"));

	const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e?.target?.value
		let _filters = { ...filters }

		_filters["global"]!.value = value

		setFilters(_filters)
		setGlobalFilterValue(value)
	}

	const dropdownOptions: { [key: string]: { name: number | boolean | string }[] } = {
		'ai_chatbot.max_token': [{ name: 256 }, { name: 512 }, { name: 1000 }],
		'ai_chatbot.max_pdf_size': [{ name: 5 }, { name: 10 }, { name: 15 }, { name: 20 }],
		'ai_chatbot.max_zip_size': [{ name: 25 }, { name: 50 }, { name: 75 }, { name: 100 }],
		// 'generation_param.max_new_tokens': [{ name: 256 }, { name: 512 }, { name: 1024 }, { name: 2048 }],
	};

	const getFormErrorMessage = (name: any) => {
		return (
			errors[name] && (
				<small className="p-error">{errors[name]?.message?.toString()}</small>
			)
		)
	}

	const initFilters = () => {
		setFilters({
			global: { value: null, matchMode: FilterMatchMode.CONTAINS },
		})
		setGlobalFilterValue("")
	}


	useEffect(() => {
		initFilters()
	}, [])


	const setValues = (fieldData?: any) => {
		// Object.keys(fieldData)?.forEach((key: any) => {
		// 	const value = fieldData[key];

		// 	if (!key.toLowerCase().includes('logo')) {
		// 		if (typeof value === 'object' && value !== null) {
		// 			Object.keys(value).forEach((nestedKey) => {
		// 				const nestedValue = value[nestedKey];
		// 				setValue(`${key}.${nestedKey}`, nestedValue);
		// 			});
		// 		} else {
		// 			setValue(key, value);
		// 		}
		// 	}
		// });



	};

	useEffect(() => {
		// setValues(fieldData)
		watch(
			(values) => {
				const changed = Object.keys(values).some((key) => {
					const originalValue = fieldData[key];
					const currentValue = values[key];
					return JSON.stringify(originalValue) !== JSON.stringify(currentValue);
				});
				setIsChatBotDataChanged(changed);
			},
			{ nested: true }
		);

	}, [watch])

	const logSource = getValues("log_source");


	const getErrorMessage = (errorKey: string): string => {
		const nestedKeys = errorKey.split('.');
		let currentError: any = errors;

		for (const key of nestedKeys) {
			if (currentError && typeof currentError === 'object' && key in currentError) {
				currentError = currentError[key];
			} else {
				return '';
			}
		}
		return currentError?.message || '';
	};


	const getMinValueForRow = (key: any) => {
		switch (key) {
			case 'ai_chatbot.temperature':
				return 0;
			case 'ai_chatbot.max_token':
				return 1;
			default:
				return 0;
		}
	};

	const getMaxValueForRow = (key: any) => {
		switch (key) {
			case 'ai_chatbot.temperature':
				return 1;
			case 'ai_chatbot.max_token':
				return 4096;
			default:
				return Infinity;
		}
	};

	const handleSystemPrompt = (e: any, data: any) => {
		// default_system_prompt: fieldData?.RON_lama_system_prompt?.default_system_prompt,
		setLabel(data.label);
		setPrompt(JSON.stringify(fieldData?.ai_chatbot.system_prompt));
		setTest(data);
		e.preventDefault()
		setShowSystemPromptModal(true)
	}
	const handleCloseSystemPrompt = () => {
		setShowSystemPromptModal(false)
	}

	const temp = (value: any) => {
		return `${JSON.parse(value)?.slice(0, 150)}...\nview more`
	}

	const updateTooltipPosition = (event: any, maxValue: number) => {
		const sliderWidth = event.target.offsetWidth;
		const sliderValue = parseFloat(event.target.value);
		const thumbWidth = 14; // Adjust according to your slider thumb size
		const tooltipWidth = 40; // Adjust according to your tooltip width
		const offsetLeft = ((sliderValue / maxValue) * (sliderWidth - thumbWidth) + (thumbWidth / 2) - (tooltipWidth / 2)) + 20;
		const offsetTop = -30; // Adjust top position as needed
		setTooltipPosition({ left: offsetLeft, top: offsetTop });
	};

	const handleChange = (event: any, maxValue: number) => {
		if (event.target.value > rangeValue && maxValue === 2) {
			setTextValue("With each increase in the threshold, Source Info's output will become less accurate, resulting in fewer relevant documents being retrieved.")
			setRangeValue(event.target.value); // Update rangeValue state when slider value changes
		} else if (event.target.value < rangeValue && maxValue === 2) {
			setTextValue("By lowering the threshold, Source Info's output will become more accurate, resulting in more relevant documents being retrieved.")
			setRangeValue(event.target.value); // Update rangeValue state when slider value changes
		}
		updateTooltipPosition(event, maxValue); // Update tooltip position
	};

	return (
		<>
			<div className="datatable-wrapper">
				<div className="w-full mb-3">
					<IconField iconPosition="right" className='user-input'>
						<InputIcon className="pi pi-search"> </InputIcon>
						<InputText
							value={globalFilterValue}
							onChange={onGlobalFilterChange}
							placeholder="Search by parameter"
							onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault(); }}
							className='search-bar-input w-full'
						/>
					</IconField>
				</div>
				<DataTable
					filters={filters}
					globalFilterFields={["label"]}
					showGridlines
					value={Backendfeilds}
					emptyMessage="No fields found."
					scrollable={true}
					scrollHeight='410px'
				>
					<Column
						header="Category"
						field="category"
						style={{ minWidth: '100px' }}
					/>
					<Column
						field="label"
						header="Parameter"
						style={{ minWidth: '300px' }}
						sortable
						body={(rowData: any, options: { rowIndex: number }) => {
							const targetId = `tooltip-${options.rowIndex}`;
							return (
								<><span className="header-tooltip">
									<span className={`tooltip-target-${options.rowIndex}`}>
										{rowData.label}
										<span className=" mr-2" style={{ color: "#FF5155" }}>*</span>
										<i
											data-bs-toggle="modal"
											data-bs-target="#Params-Info"
											onClick={() => setModalContent(rowData.toolTipInfo)}
											style={{ cursor: "pointer" }}
										>
											<img src={infoIcon} alt='info-icon' />
										</i>
									</span>
								</span>
								</>
							);
						}}
					// sortField='label'
					>
					</Column>

					<Column
						header="Field 1"
						field='field1'
						style={{ minWidth: '150px' }}
					/>
					<Column
						header="Field 2"
						field='field2'
						style={{ minWidth: '150px' }}
					/>
					<Column
						header="Value"
						style={{ minWidth: '600px' }}
						body={(rowData, index) => (
							<span key={rowData.key}>
								{
									rowData.type === "text" ?
										(<>
											<Controller
												name={rowData.key}
												control={methods.control}
												rules={{
													required: `${rowData.label} is required`,
													...(rowData.type === "number" && {
														min: {
															value: getMinValueForRow(rowData.key),
															message: `Value must be minimum ${getMinValueForRow(rowData.key)} to maximum ${getMaxValueForRow(rowData.key)}`,
														},
														max: {
															value: getMaxValueForRow(rowData.key),
															message: `Value must be minimum ${getMinValueForRow(rowData.key)} to maximum ${getMaxValueForRow(rowData.key)}`,
														},
													}),
												}}
												render={({ field }) => (
													<>
														<div className="param-tab-form">
															<div className='form-row'>
																<div className='form-col'>
																	<InputText
																		className="w-full"
																		disabled={clientVersion !== "" ? true : false || rowData.key === "ai_chatbot.log_url" || rowData.key === "ai_chatbot.source_name"}
																		type={rowData.type}
																		placeholder={
																			rowData.type === "number" ?
																				(isFinite(getMinValueForRow(rowData.key)) && isFinite(getMaxValueForRow(rowData.key))) ?
																					`Enter Number (${getMinValueForRow(rowData.key)} - ${getMaxValueForRow(rowData.key)})` :
																					"Enter Number"
																				:
																				rowData.type === "password"
																					? "Enter your password"
																					: "Enter your Text here"
																		}
																		{...field}
																	/>
																	<p style={{ color: "#FF5155" }}>{getErrorMessage(rowData.key)}</p>
																</div>
															</div>
														</div>
													</>
												)}
											/>
										</>)
										: rowData.type === "dropdown" ? (
											<Controller
												name={rowData.key}
												control={methods.control}
												// defaultValue=""
												rules={{
													required: `${rowData.field} is Required`,
												}}
												render={({ field }) => (
													<>
														<div className="param-tab-form">
															<div className='form-row'>
																<div className='form-col'>
																	<Dropdown
																		{...field}
																		options={dropdownOptions[rowData.key]}
																		onChange={(e) => setValue(rowData.key, e.target.value, { shouldValidate: true })}
																		placeholder="Select an option"
																		value={field.value}
																		optionLabel="name"
																		disabled={clientVersion !== "" ? true : false}
																		className={`w-100`}
																	/>
																	<p style={{ color: "#FF5155" }}>{errors[`${rowData.field}`]?.message?.toString()}</p>
																</div>
															</div>
														</div>
													</>
												)}
											/>
										)
											:
											rowData.type === "slider" ? (
												<Controller
													name={rowData.key}
													control={methods.control}
													render={({ field: { onBlur, onChange, value } }) => (
														<div className="w-full">
															{/* <div className="d-flex justify-content-center fw-bold align-items-center">
																									<span style={{ fontSize: "large" }}>{field.value ? field.value : 0}</span>
																								</div> */}
															{/* <div style={{ position: 'relative' }}> */}
															{/* <div className="d-flex align-items-center"> */}
															{/* <p className="mr-3">{0}</p> */}
															{/* <Slider
																										{...field}
																										className="w-full"
																										onChange={(e: any) => {
																											// setSlideValue(e.target.value);
																											setValue(rowData.key, e.value, { shouldValidate: true });
																										}}
																										min={0}
																										max={rowData.key === "faiss_vactor_db.source_info_threshold" ? 2 : 1}
																										step={0.1}
																										value={field.value}
																									/> */}
															<div className="range-slider-container">
																<div className="d-flex flex-column">
																	<span>
																		<input
																			type="range"
																			className="w-full"
																			min={0} // Minimum value
																			max={1} // Maximum value
																			value={value} // Current value
																			onChange={(e) => { handleChange(e, 1); onChange(e.target.value) }} // Handle change event
																			onMouseOver={(e) => { updateTooltipPosition(e, 1); }}
																			onMouseOut={() => setTooltipPosition({ left: 0, top: 0 })}
																			step={0.1}
																			disabled={clientVersion !== "" ? true : false}
																		/>
																		{/* Tooltip to display current value */}
																		{(value || value === 0) && tooltipPosition.top !== 0 && tooltipPosition.left !== 0 &&
																			<span className="tooltip" style={{ left: tooltipPosition.left }}>
																				{value}
																			</span>
																		}
																	</span>
																	<div className="d-flex justify-content-between">
																		<span className="fw-bold">0</span>
																		<span className="fw-bold">1</span>
																	</div>
																</div>
															</div>
															{rowData.key === "faiss_vactor_db.source_info_threshold" &&
																<span className="fw-medium">{textValue}</span>
															}
															{/* <p className="ml-3">{rowData.key === "faiss_vactor_db.source_info_threshold" ? 2 : 1}</p> */}
															{/* </div> */}
															{/* <div style={{ position: 'absolute', top: '-8px', left: '50%', transform: 'translateX(-50%)', fontWeight: "500" }}> */}

															{/* <p className="text-danger">{getErrorMessage(rowData.key)}</p> */}
														</div>
													)}
												/>

											)
												:
												(
													<span data-bs-toggle="modal" data-bs-target="#active-deactive" onClick={(e) => {
														handleSystemPrompt(e, rowData)
													}}>
														<Controller
															name={rowData.key}
															control={methods.control}
															defaultValue=""
															rules={{
																required: `${rowData.field} is Required`,
															}}
															render={({ field }) => (
																<>
																	{/* <InputTextarea
															{...field}
															value={temp(JSON.stringify(field?.value)) as any}
															// value={field.value}
															// value={field.value.replace(/\\n/g, '\n')}
															disabled={clientVersion !== "" ? true : false}
															rows={5}
															cols={30}
															className="w-full c-pointer"
														/> */}
																	<div className="border border-secondary-subtle p-1 d-flex flex-column justify-content-between ">
																		{/* <ReactMarkdown>{`${JSON.parse(field?.value).slice(0, 150)}...`}</ReactMarkdown> */}
																		{/* {MarkdownRenderer(field?.value)} */}
																		<ReactMarkdown
																			components={{
																				// Paragraphs
																				p: ({ node, ...props }) => <p className={styles['markdown-paragraph']} {...props} />,
																				// Headings
																				h1: ({ node, ...props }) => (
																					<h1
																						className={styles['markdown-heading1']}
																						{...props}
																					/>
																				),
																				h2: ({ node, ...props }) => (
																					<h2
																						className={styles['markdown-heading2']}
																						{...props}
																					/>
																				),
																				h3: ({ node, ...props }) => (
																					<h3
																						className={styles['markdown-heading3']}
																						{...props}
																					/>
																				),
																				h4: ({ node, ...props }) => (
																					<h4
																						className={styles['markdown-heading4']}
																						{...props}
																					/>
																				),
																				h5: ({ node, ...props }) => (
																					<h5
																						className={styles['markdown-heading5']}
																						{...props}
																					/>
																				),
																				h6: ({ node, ...props }) => (
																					<h6
																						className={styles['markdown-heading6']}
																						{...props}
																					/>
																				),

																				// Lists
																				ul: ({ node, ...props }) => (
																					<ul
																						className={styles['markdown-unordered-list']}
																						{...props}
																					/>
																				),
																				ol: ({ node, ordered, ...props }) => (
																					<ol
																						className={styles['markdown-ordered-list']}
																						{...props}
																					/>
																				),

																				// List Items
																				li: ({ node, ordered, ...props }) => (
																					<li
																						className={styles['markdown-list-item']}
																						{...props}
																					/>
																				),

																				// Links
																				a: ({ node, ...props }: any) => (
																					<a
																						className={styles['markdown-link']}
																						href={node.href}
																						{...props}
																					>
																						{props.children}
																					</a>
																				),

																				// Code Blocks styling or auto formatting API response...
																				pre: ({ node, ...props }) => (
																					<pre
																						className={styles['markdown-code-block']}
																						{...props}
																					/>
																				),
																				code: ({ inline, node, ...props }) => {
																					if (inline) {
																						return (
																							<code
																								className={styles['markdown-inline-code']}
																								{...props}
																							/>
																						);
																					}
																					return (
																						//     <SyntaxHighlighter language="javascript" >
																						//     {props.children}
																						// </SyntaxHighlighter>

																						<p>{props.children}</p>
																					);
																				},

																				// Blockquotes
																				blockquote: ({ node, ...props }) => (
																					<blockquote
																						className={styles['markdown-blockquote']}
																						{...props}
																					/>
																				),

																				// Images
																				img: ({ node, ...props }: any) => (
																					<img
																						className={styles['markdown-image']}
																						src={node.src}
																						alt={node.alt}
																						{...props}
																					/>
																				),

																				// Table Headers
																				th: ({ node, ...props }) => (
																					<th
																						className={styles['markdown-table-header']}
																						{...props}
																					/>
																				),

																				// Table Cells
																				td: ({ node, ...props }) => (
																					<td
																						className={styles['markdown-table-cell']}
																						{...props}
																					/>
																				),

																				// Add other components and styles as needed
																			}}
																		>
																			{`${JSON.parse(JSON.stringify(field?.value)).slice(0, 150)}...`}
																		</ReactMarkdown>
																		<span className="fw-bold text-primary c-pointer">View more</span>
																		{/* <span className="fw-bold d-flex flex-row-reverse text-primary">View more</span> */}
																	</div>
																</>
															)}
														/>
													</span>
													// <div className='d-flex'>
													// 	<Button className='btn btn-primary btn-sm px-3' data-bs-toggle="modal" data-bs-target="#active-deactive" onClick={(e) => {
													// 		handleSystemPrompt(e, rowData)
													// 	}}>Click here</Button>

													// </div>

												)
								}
							</span>
						)}
					/>
				</DataTable>
			</div>
			<ParamsPopUp content={modalContent} />
			<SystemPromptModal handleCloseSystemPrompt={handleCloseSystemPrompt} label={label} prompt={prompt} handelPrompt={handelPrompt} />
		</>
	);

};

export default ChatBotParams;